export const FEED_INVALIDATION_EVENT = 'personalinsights:feed-invalidated';

export function invalidateFeed(reason = 'manual') {
  window.dispatchEvent(
    new CustomEvent(FEED_INVALIDATION_EVENT, {
      detail: {
        reason,
        at: Date.now(),
      },
    })
  );
}
